import { render, staticRenderFns } from "./CpRequestsEmpty.vue?vue&type=template&id=2d9f0e68&"
import script from "./CpRequestsEmpty.vue?vue&type=script&lang=js&"
export * from "./CpRequestsEmpty.vue?vue&type=script&lang=js&"
import style0 from "./CpRequestsEmpty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports